import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL);

export default {
    getAddressList(data) {
        return axios.request({
            url: "user/addresslist",
            method: "post",
            data
        }).then((res)=>{
            if(res.status*1===200){
                let list = res.data.list
                list.forEach((item,index)=>{
                    item.tel = item.mobile
                    // item.fulladdress = `${item.province} ${item.city} ${item.district} ${item.address}`
                })
            }

            return res

        });
    },
    editAddress(data) {
        return axios.request({
            url: "user/addressedit",
            method: "post",
            data
        });
    },
    getAddress(data) {

        return axios.request({
            url: "user/addressdetail",
            method: "post",
            data
        });
    },
    delAddress(data) {
        return axios.request({
            url: "user/addressdel",
            method: "post",
            data
        });
    }
}
